import { getDocs, collection, doc, updateDoc } from "firebase/firestore";
import { db } from '../../../firebase/config';

export type PSO = {
    id: string;
    name: string;
    contact?: string;
    email?: string;
    designation?: string;
    authUid?: string;
    isActive?: boolean;
    deactivationReason?: string;
    deactivationDate?: string;
    createdAt?: any;
    updatedAt?: any;
};

export async function fetchPSOs(bankId: string): Promise<PSO[]> {
    const psoSnap = await getDocs(collection(db, "banks", bankId, "pos"));
    const psoList: PSO[] = psoSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    } as PSO));

    // Sort by name
    psoList.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        return nameA.localeCompare(nameB);
    });

    console.log('Fetched PSOs:', psoList.length);

    return psoList;
}

export async function updatePSO(bankId: string, psoId: string, data: Partial<PSO>): Promise<void> {
    const psoRef = doc(db, "banks", bankId, "pos", psoId);
    const updateData = { ...data, updatedAt: new Date() };
    await updateDoc(psoRef, updateData);
}

